









































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PagesCoreAppBar extends Vue {
  items = [
    {
      icon: this.$store.getters['app/icons'].login,
      text: 'Login',
      to: '/login',
    },
    {
      icon: this.$store.getters['app/icons'].register,
      text: 'Register',
      to: '/register',
    },
    {
      icon: this.$store.getters['app/icons'].password,
      text: 'Forgotten Password',
      to: '/forgot',
    },
  ];


  isButtonHidden(item: string) {
    if (item === this.$route.path || this.$route.path === '/register/more' || this.$store.getters['users/loggedInUser'].loggedIn) {
      return 'hide-me';
    }
    return '';
  }
}
